<template>
    <div class="container search">
        <div class="row">
            <div class="col-md-12">
                <div class="row flex-column-reverse flex-sm-row">
                    <div class="col-md-6">
                        <h2>
                            Create Claim
                        </h2>
                    </div>
                </div>
                <EditClaim></EditClaim>
            </div>
        </div>
    </div>
</template>
<script>
import EditClaim from './EditClaim.vue'
export default {
    components: {
        EditClaim
    },
    created() {
    },
    mounted() {
    },
    data() {
        return {
        }
    },
    computed: {},
    methods: {
    }
}
</script>



// WEBPACK FOOTER //
// resources/js/components/Claims/CreateClaimPage.vue